<template>
  <div class="list-content">
    <div class="order-list">
      <van-list v-model="listLoading" :finished="finished" :finished-text="finishedText" @load="nextPage">
        <van-cell v-for="(item, index) in list" :key="index">
          <div class="list-item" @click="goDetail(item)">
            <div class="top-box">
              <div class="text">投保时间：{{ item.createTime | transformTime | timeSub(16) }}</div>
              <div class="tag" :class="checkStatus(item)">
                {{ item.status }}</div>
            </div>
            <div class="content-box">
              <div class="title">{{ item.productName }}</div>
              <div class="left-box" :class="{ 'full': !item.commission }">
                <div class="text" v-if="item.salesman"><span class="label">出单人：</span>{{ item.salesman }}</div>
                <div class="text text-name"><span class="label">投保人：</span>{{ item.holderName }}</div>
                <div class="text gift" v-if="item.isGift == 1">0元投保</div>
                <div class="text" v-else><span class="label">保费：</span>{{ item.fee }}元</div>
              </div>
              <div class="right-box" v-if="item.commission">
                <div class="text-box">
                  <div class="text1">+{{ item.commission }}元</div>
                  <div class="text2">预估服务费</div>
                </div>
              </div>
            </div>
          </div>
        </van-cell>
        <div class="null" v-if="list.length <= 0 && !listLoading">
          <img class="null-img" src="@static/images/null.png">
          <span class="null-text">暂无内容</span>
        </div>
      </van-list>
    </div>
  </div>
  <!-- 引导分享 -->
</template>

<script>
import { pageTools, common } from "@/api/mixins";
export default {
  mixins: [pageTools, common],
  data() {
    return {
      list: [],
    };
  },
  watch: {},
  mounted() { },
  methods: {
    goDetail(item) {
        if (item.detailUrl) {
          this.$app.openWeb(item.detailUrl,null,'partner')
        } else {
          if (this.$config.isApp) {
            this.$app.openWeb(location.origin + `/apps/groupOrder/detail?orderNo=${item.orderNo}&policyNo=${item.policyNo}`);
          } else {
            this.goPage('/apps/groupOrder/detail', { orderNo: item.orderNo, policyNo: item.policyNo })
          }
        }
    },
    checkStatus(item) {
      //核保状态 -5：核保失败 -2：承保失败,0：待投保,1：待支付,2：待实收,3：待承保,5：核保中,4：已完成
      //保单状态  1-保障中 -1-退保 0-终止
      let colorStr = '';
      //默认灰色
      //承保失败、核保失败、已退保、已终保用灰色。已退款（如果有）也用灰色

      //待投保、核保中、待支付、待实收、待承保、保障中用蓝色
      if (['0', '5', '1', '2', '3', '4'].includes(item.checkInsuranceStatus) && item.policyStatus != '-1' && item.policyStatus != '0') {
        colorStr = 'blue'
      }
      return colorStr
    },
    init(url) {
      this.pageNum = 1;
      this.initListAjax(url)
    },
    // 设置自定义参数
    setListParams(params) {
      this.$emit("setListParams", params);
    },
    listCallback(res) {
      this.$emit("listCallback", res);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./list.scss";
</style>
